// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__6Lqzb","wrapper":"styles_wrapper__3laH2"};